import { render, staticRenderFns } from "./BaseMultiSelect.vue?vue&type=template&id=676d9d41&scoped=true"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d9d41",
  null
  
)

export default component.exports